import {
  ArrowsRightLeftIcon,
  ClipboardIcon,
} from "@heroicons/react/24/outline";
import { Info } from "../info";
import { useTranslation } from "react-i18next";

export const ComplaintsMapIntro: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="text-2xl text-text-primary mb-10">
        {t("pages.complaints_map_intro.title")}
      </div>
      <div className="flex flex-col gap-6 mt-4">
        <Info Icon={ClipboardIcon}>
          {t("pages.complaints_map_intro.part_one")}
        </Info>
        <Info Icon={ArrowsRightLeftIcon}>
          {t("pages.complaints_map_intro.part_two")}
        </Info>
      </div>
    </div>
  );
};
